// import logo from './assets/images/logo.webp';
import "./App.css";
import MyComponent from "./Components/MyComponent";

function App() {
  return <MyComponent />;
}

export default App;
